import { render, staticRenderFns } from "./tab-company.vue?vue&type=template&id=3cdb2c93&scoped=true"
import script from "./tab-company.vue?vue&type=script&lang=js"
export * from "./tab-company.vue?vue&type=script&lang=js"
import style0 from "./tab-company.vue?vue&type=style&index=0&id=3cdb2c93&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdb2c93",
  null
  
)

export default component.exports